import React from 'react';
import * as images from '../../../assets';

export const CloseX = ({close, style, raised}) => {
    return <img onClick={close} className={`text-right order-x-icon${raised ? " raised" : ""}`} src={images.btn_close_x} style={style} alt="close" />
}